//Types para info Service
export const GET_ARTICULOS = "GET_ARTICULOS";
export const SET_ARTICULOS = "SET_ARTICULOS";
export const SET_CAD_BUSQUEDA = "SET_CAD_BUSQUEDA";
export const SET_FILTRAR_ARTICULOS = "SET_FILTRAR_ARTICULOS";
export const NO_FILTRAR_ARTICULOS = "NO_FILTRAR_ARTICULOS";
export const SET_CATEGORIAS = "SET_CATEGORIAS";
export const SET_RESULTS_PAGE = "SET_RESULTS_PAGE";